import { RootState } from "@/store/store";
import type { GUID } from "@faro-lotv/foundation";

/**
 * @returns the ID of the entity a hierarchy change is being saved for, else null
 * @param state current app state
 */
export function selectHierarchySaveTargetId(state: RootState): GUID | null {
  return state.dataPreparationUi.hierarchySaveTargetId;
}

/**
 * @returns whether the most recent hierarchy change (drag & drop in the scan tree) failed to save to the cloud
 * @param state current app state
 */
export function selectDidHierarchySaveFail(state: RootState): boolean {
  return state.dataPreparationUi.didHierarchySaveFail;
}

/**
 * @returns whether a hierarchy change (drag & drop in the scan tree) is being saved to the cloud
 * @param state current app state
 */
export function selectIsSavingHierarchyChanges(state: RootState): boolean {
  return state.dataPreparationUi.isSavingHierarchyChanges;
}

/**
 * @returns whether the user edits are being saved to the cloud
 * @param state current app state
 */
export function selectIsSavingUserEdits(state: RootState): boolean {
  return state.dataPreparationUi.isSavingUserEdits;
}

/**
 * @returns whether any draft changes (user edits or hierarchy changes) are being saved to the cloud.
 *  While this is the case, the user must not trigger further changes to the project.
 * @param state current app state
 */
export function selectIsSavingDraftChanges(state: RootState): boolean {
  return (
    selectIsSavingHierarchyChanges(state) || selectIsSavingUserEdits(state)
  );
}

/**
 * @returns whether the blocking dialog is shown while pending draft changes are saved
 * @param state current app state
 */
export function selectIsSavingDialogOpen(state: RootState): boolean {
  return state.dataPreparationUi.isSavingDialogOpen;
}
